import { Component, inject, input, output } from "@angular/core";
import { Params, RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MaterialModule } from "../../../material.module";
import { IconsService } from "../../../services/icons/icons.service";

@Component({
    selector: "app-back-button",
    templateUrl: "./back-button.component.html",
    imports: [FontAwesomeModule, MaterialModule, RouterModule],
    host: {
        class: "flex flex-none mr-[15px]",
    },
})
export class BackButtonComponent {
    readonly icons = inject(IconsService);
    readonly route = input<string | readonly unknown[]>();
    readonly queryParams = input<Params>();
    readonly ariaLabel = input("Go back");
    readonly clicked = output<void>();
}
